module.exports = __webpack_public_path__ + "img/step5-mobile-fr.4dcb7468.webp";